export const getFilterValueData = (state: any) => state.filterValue;
